import { createContext, useContext, useMemo } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Growl } from '../Components'
import { useLocalStorage } from '../Hooks/useLocalStorage'
import { FC } from '../Services/FeathersClient'
import { cap } from '../State'
import { translations } from '../translations'
import { showToast } from '../utils/toast'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

const AuthContext = createContext(null)

function AuthProvider() {
  const [user, setUser] = useLocalStorage('user', null)
  const navigate = useNavigate()
  const location = useLocation()

  const onLogin = async (loginData) => {
    // (userData) => async () => {
    const user = await FC.login({ ...loginData, strategy: 'local' })
    if (!user) return showToast('error', t.errore, t.mcCredenzialiErrate)
    setUser(user)
    const origin = location?.state?.from?.pathname || '/operatore/list'
    await new Promise(() => setTimeout(() => navigate(origin), 100))
  }

  const onLoginJWT = async (jwt) => {
    const user = await FC.login({ strategy: 'jwt', accessToken: jwt })
    setUser(user)
  }

  const onLogout = () => {
    FC.logout()
    setUser(null)
    navigate('/login')
  }

  const value = useMemo(() => ({
    user,
    onLogin,
    onLoginJWT,
    onLogout
  }))

  return (
    <AuthContext.Provider value={value}>
      <Growl />
      <Outlet />
    </AuthContext.Provider>
  )
}

export default AuthProvider

export const useAuth = () => useContext(AuthContext)
